var hr = {};
module['exports'] = hr;
hr.title = "Hrvatski";
hr.address = require("./address");
hr.internet = require("./internet");
hr.name = require("./name");
hr.phone_number = require("./phone_number");
hr.cell_phone = require("./phone_number");
hr.date = require("./date");